export enum ScheduleStatus {
    Created = 0,
    Issued = 1,
    Started = 2,
    Completed = 3,
    Paused = 4,
}